import { useContext } from 'react'
import { i18n } from './index'
import { LanguageContext, type LanguageContextType } from './languageContext.js'
import { localeByLanguage } from './localeHelper'

export const useLanguage = (): LanguageContextType => {
  return useContext(LanguageContext)
}

export const useTranslations = () => {
  const [language, _] = useLanguage()
  return i18n.languages[language]
}

export const useLocale = (): string => {
  const [language] = useLanguage()
  return localeByLanguage[language]
}
